import formatUpdatePriceBandPayload from './formatUpdatePriceBandPayload';
export default formatUpdatePriceBandPayload;
